module.exports = __webpack_public_path__ + "static/media/Base_Build_Up_Tarmac.17a97ea9.pdf";